import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DashboardImgBlack from "../assets/dashboarddd.svg";
import DashboardImgWhite from "../assets/dashboardddwh.svg";
import Analytics from "../assets/download.svg";
import AnalyticsBl from "../assets/downloadBl.svg";
import DownArrow from "../assets/dropArrowWHite.svg";
import Dummy from "../assets/DummyNew.png";
import profileseticn from "../assets/logoutIcn.svg";
import SearchIcon from "../assets/megnfineSearc.svg";
import SearchIconBl from "../assets/megnfineSearcBl.svg";
import OpenMenu from "../assets/menu_openWHite.svg";
import logicn from "../assets/profileseticn.svg";
import {
  handleError,
  handleLinkClick,
  handleSuccess,
  inputdateformateChangeyear,
} from "../CommonJquery/CommonJquery.js";
import {
  removeData,
  retrieveData,
} from "../LocalConnection/LocalConnection.js";
import {
  get_searchmaster,
  server_post_data,
} from "../ServiceConnection/serviceconnection.js";
import NotificationBar from "./NotificationBar.js";
import SideBar from "./SideBar.js";
function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [options, setoptions] = useState([]);
  const [notificationsCount, setnotificationsCount] = useState(0);
  const admin_name_with_gender = retrieveData("admin_name_with_gender");
  const designation_name = retrieveData("designation_name");
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);

  useEffect(() => {
    const retrievedDataFind = retrieveData("designation_name");
    if (
      retrievedDataFind === "null" ||
      retrievedDataFind === null ||
      retrievedDataFind === "1"
    ) {
      navigate("/");
      return; // Aage ka code execute nahi hoga
    }
  }, []);

  useEffect(() => {
    const retrivemsg = retrieveData("session_msg");
    if (
      retrivemsg !== "" &&
      retrivemsg !== null &&
      retrivemsg !== "0" &&
      retrivemsg !== "1"
    ) {
      handleSuccess(retrivemsg, 1);
    }
    checkTime();
  }, []);

  useEffect(() => {
    master_data_get();
  }, [notificationsCount]);

  //sidebar open
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const sideBarRef = useRef(null);
  const toggleSidebar = () => {
    if (!isAnimating) {
      setIsAnimating(true);
      setIsSidebarOpen(!isSidebarOpen);

      // Reset animating state after transition completes
      setTimeout(() => {
        setIsAnimating(false);
      }, 300); // Match your CSS transition time
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sideBarRef.current && !sideBarRef.current.contains(event.target)) {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //notification sidebaar
  const toggleNotification = () => {
    setIsNotificationOpen(!isNotificationOpen);
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };
  const handleNotificationClickOutside = (event) => {
    if (
      notificationRef.current &&
      !notificationRef.current.contains(event.target) &&
      isNotificationOpen
    ) {
      setIsNotificationOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleNotificationClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleNotificationClickOutside);
    };
  }, [isNotificationOpen]);

  const notificationRef = useRef(null);

  const checkTime = () => {
    try {
      let now = new Date();
      let hr = now.getHours();
      let min = now.getMinutes();
      let seconds = now.getSeconds();
      let hours = document.querySelector(".hours");
      let minutes = document.querySelector(".minutes");

      if (hr < 10) {
        hr = "0" + hr;
      }
      if (min < 10) {
        min = "0" + min;
      }
      if (hours && minutes) {
        hours.textContent = hr + " : ";
        minutes.textContent = min;
      }

      // Calculate remaining seconds until the next minute
      let remainingSeconds = 59 - seconds;

      if (Number(remainingSeconds) < 2) {
        remainingSeconds = 60;
      }

      // Set the interval based on remaining seconds
      setTimeout(checkTime, remainingSeconds * 1000);
    } catch (err) {
      console.log(err);
    }
  };
  const logoutpopup = () => {
    setShowModal(false);
    removeData();
    navigate("/");
  };

  const handleSearchButtonClick = () => {
    const storedSearchHistory = localStorage.getItem("searchHistory");
    if (storedSearchHistory) {
      const searchHistory = JSON.parse(storedSearchHistory);
      setSearchResults(searchHistory.slice(-5));
    } else {
      setSearchResults([]);
    }
    setIsSearchActive(true);
  };

  const master_data_get = async () => {
    const fd = new FormData();
    fd.append("flag", "1");
    fd.append("from_where", "0");
    await server_post_data(get_searchmaster, fd)
      .then((Response) => {
        // console.log(Response.data);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setoptions(Response.data.message.data_search);
          setnotificationsCount(
            Response.data.message.data_reservation_data.length,
          );
        }
      })
      .catch((error) => {
        handleError("network");
      });
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (value.trim() === "") {
      setSearchResults([]);
    } else {
      const filteredResults = options.filter(
        (option) =>
          option.master_name.toLowerCase().includes(value.toLowerCase()) ||
          option.master_value
            .toLowerCase()
            .split(",") // Split the value string by commas
            .some((subValue) => subValue.trim().includes(value.toLowerCase())), // Check if any substring matches the search term
      );
      setSearchResults(filteredResults);
    }
    setIsSearchActive(true);
  };

  const handleSearchResultClick = (result) => {
    const storedSearchHistory = localStorage.getItem("searchHistory");
    let searchHistory = storedSearchHistory
      ? JSON.parse(storedSearchHistory)
      : [];
    const index = searchHistory.findIndex(
      (item) => item.master_url === result.master_url,
    );
    if (index !== -1) {
      searchHistory.splice(index, 1);
    }
    searchHistory = [result, ...searchHistory.slice(0, 4)];

    localStorage.setItem("searchHistory", JSON.stringify(searchHistory));
    window.location.href = window.location.origin + "/" + result.master_url;
  };

  const headSearchRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        headSearchRef.current &&
        !headSearchRef.current.contains(event.target)
      ) {
        setIsSearchActive(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [headSearchRef]);

  /******* Upper Search Close**********/
  return (
    <div className="header">
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid nav_container p-0">
          <div className="navbar-collapse" id="navbarNav">
            <span className="accesibilities">
              <div
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                htmlFor="top"
                title={`Open`}
                className={`menuOpenClose `}
                onClick={toggleSidebar}
                style={{ paddingLeft: "0" }}
              >
                <img src={OpenMenu} alt="Uprestro Dashboard" />
              </div>
              <div className="accesibilitiesIcons">
                <Link
                  rel="noopener"
                  onClick={() => handleLinkClick("/Dashboard")}
                >
                  <button
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    htmlFor="top"
                    title={`Dashboard`}
                    className={` ${
                      location.pathname === "/Dashboard"
                        ? "selectedHeadBtn"
                        : ""
                    } `}
                  >
                    {location.pathname === "/Dashboard" ? (
                      <img src={DashboardImgBlack} alt="Uprestro Dashboard" />
                    ) : (
                      <img src={DashboardImgWhite} alt="Uprestro Dashboard" />
                    )}
                  </button>
                </Link>
                {/* <Link
                  rel="noopener"
                  onClick={() => handleLinkClick("/Reservation_Calendar")}
                >
                  <button
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    htmlFor="top"
                    title={`Reservation Management`}
                    className={` ${
                      location.pathname === "/Reservation_Calendar"
                        ? "selectedHeadBtn"
                        : ""
                    } `}
                  >
                    <img src={CalendarImg} alt="Uprestro Dashboard" />
                  </button>
                </Link> */}
              </div>
              {/* <Link
                rel="noopener"
                onClick={() => handleLinkClick("/Create_Reservation")}
              >
                <button
                  className={` rsrvHeadBtn ${
                    location.pathname === "/Create_Reservation"
                      ? "selectedHeadBtn"
                      : ""
                  } `}
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  htmlFor="top"
                  title={`Create Reservation`}
                >
                  <img src={AddIcon} alt="Uprestro Dashboard" />
                  <p
                    className={` ${
                      location.pathname === "/Create_Reservation"
                        ? "showOnActive"
                        : "hideAfter1150"
                    }`}
                  >
                    RESERVATION
                  </p>
                </button>
              </Link>
              <Link
                rel="noopener"
                onClick={() => handleLinkClick("/Create_WalkIn")}
              >
                <button
                  className={` rsrvHeadBtn ${
                    location.pathname === "/Create_WalkIn"
                      ? "selectedHeadBtn"
                      : ""
                  } `}
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  htmlFor="top"
                  title={`Create Walk-In Reservation`}
                >
                  <img src={Walking} alt="Uprestro Dashboard" />
                  <p
                    className={` ${
                      location.pathname === "/Create_WalkIn"
                        ? "showOnActive"
                        : "hideAfter1150"
                    }`}
                  >
                    WALK-IN
                  </p>
                </button>
              </Link> */}
              {!isSearchActive && (
                <div
                  className="accesibilitiesIcons"
                  ref={headSearchRef}
                  onClick={handleSearchButtonClick}
                >
                  <button
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    htmlFor="top"
                    title={`Search`}
                    onClick={() => setIsSearchActive(true)}
                  >
                    <img
                      style={{ width: "27px" }}
                      src={SearchIcon}
                      alt="Uprestro Dashboard"
                    />
                  </button>
                </div>
              )}
              {isSearchActive && (
                <div className="headSearch" ref={headSearchRef}>
                  <div className="headSearchInput">
                    <img src={SearchIconBl} alt="Uprestro Dashboard" />
                    <input
                      type="text"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div
                    className={`searchDropdownBox ${
                      isSearchActive && searchResults.length > 0 ? "" : "d-none"
                    }`}
                  >
                    <ul>
                      {searchResults.map((result, index) => (
                        <li
                          key={index}
                          onClick={() => handleSearchResultClick(result)}
                        >
                          {result.master_name}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </span>
            <ul className="navbar-nav">
              <li className="nav-item">
                <div className="timeANdDateHead">
                  <p className="dateHeadb">{inputdateformateChangeyear("")}</p>
                  <p>
                    <span className="hours">0</span>
                    <span className="minutes">0</span>
                  </p>
                </div>
              </li>
              <Link rel="noopener" onClick={() => handleLinkClick("/Manuals")}>
                <li className="nav-item">
                  <div className="accesibilities">
                    <button
                      className={` rsrvHeadBtn ${
                        location.pathname === "/Manuals"
                          ? "selectedHeadBtn"
                          : ""
                      } `}
                    >
                      <p>HELP</p>
                    </button>
                  </div>
                </li>
              </Link>
              <li className="nav-item">
                <span className="profileLink nav-link active paddRight0 flexDirectionClss">
                  <img
                    style={{ borderRadius: "10px" }}
                    src={Dummy}
                    alt="Uprestro Dashboard"
                  />
                  <div className="dropdown profileDropdown">
                    <div
                      className="profileBtnToggle dropdown-toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span>
                        <h6>{admin_name_with_gender}</h6>
                        <p>{designation_name}</p>
                      </span>
                      <img
                        className="togglePBTN"
                        src={DownArrow}
                        alt="Uprestro Dashboard"
                      />
                    </div>
                    <ul className="dropdown-menu">
                      <li>
                        <Link
                          rel="noopener"
                          className="dropdown-item"
                          onClick={() => handleLinkClick("/Profile_Settings")}
                        >
                          {" "}
                          <div className="profilOuticn">
                            <img
                              className="profilimg"
                              src={profileseticn}
                              alt="img"
                            ></img>
                            My Profile
                          </div>
                        </Link>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => openModal()}
                        >
                          <div className="logOuticn">
                            <img
                              className="logOutimg"
                              src={logicn}
                              alt="img"
                            ></img>
                            Logout
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </span>
              </li>
              {/* <li className="nav-item">
                <div className="saparatorDiv"></div>
              </li> */}
              <Link
                rel="noopener"
                onClick={() => handleLinkClick("/Analytics")}
              >
                {/* <li className="nav-item">
                  <div className="accesibilities">
                    <div className="accesibilitiesIcons">
                      <button
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        htmlFor="top"
                        title={`Analytics`}
                        className={` ${
                          location.pathname === "/Analytics"
                            ? "selectedHeadBtn"
                            : ""
                        } `}
                      >
                        {location.pathname === "/Analytics" ? (
                          <img src={AnalyticsBl} alt="Uprestro Dashboard" />
                        ) : (
                          <img src={Analytics} alt="Uprestro Dashboard" />
                        )}
                      </button>
                    </div>
                  </div>
                </li> */}
              </Link>
            </ul>
          </div>
        </div>
      </nav>
      <Modal show={showModal} onHide={closeModal} centered backdrop="static">
        <Modal.Body className="modal_body">
          <div className="success_img d-flex justify-content-center">
            {/* ... Modal content goes here ... */}
          </div>

          <p>Are you sure you want to Logout?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="logoutYesBtn" onClick={logoutpopup}>
            Yes
          </Button>
          <Button className="logoutNoBtn" onClick={closeModal}>
            No
          </Button>
        </Modal.Footer>
      </Modal>

      <div ref={sideBarRef}>
        <SideBar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      </div>
      <div className="notification-component" ref={notificationRef}>
        {isNotificationOpen && (
          <NotificationBar toggleNotification={toggleNotification} />
        )}
      </div>
    </div>
  );
}

export default Header;
